export class GuestWish {
  partnersName: string;
  contribution: string;
  registryId: string;
  yourName: string;
  fromNames: string;
  wishText: string;
  email: string;
}



// WEBPACK FOOTER //
// ./src/app/gift-wish/wish.ts